import { useEffect, useRef, useState } from "react";
import { menuPdfs } from "../../data/menuPdfs";

function MenuPdfDropdown({ t }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const options = [
    {
      kind: "foods",
      label: t.pdf.optionFood,
      href: menuPdfs.foods.href,
      download: menuPdfs.foods.download,
    },
    {
      kind: "drinks",
      label: t.pdf.optionDrink,
      href: menuPdfs.drinks.href,
      download: menuPdfs.drinks.download,
    },
  ];

  useEffect(() => {
    function handleClickOutside(event) {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    function handleEscape(event) {
      if (event.key === "Escape") setOpen(false);
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  return (
    <div
      className={`menu-pdf-dropdown${open ? " is-open" : ""}`}
      ref={rootRef}
    >
      <button
        type="button"
        className="menu-pdf-dropdown-trigger"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={t.pdf.btnLabel}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>{t.pdf.btn}</span>
        <span className="menu-pdf-dropdown-chevron" aria-hidden="true" />
      </button>

      {open ? (
        <ul className="menu-pdf-dropdown-menu" role="menu" aria-label={t.pdf.btnLabel}>
          {options.map((option) => (
            <li key={option.kind} role="none">
              <a
                role="menuitem"
                className="menu-pdf-dropdown-option"
                href={option.href}
                download={option.download}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setOpen(false)}
              >
                {option.label}
                <span className="visually-hidden"> {t.pdf.openHint}</span>
              </a>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}

export default MenuPdfDropdown;
